import { inject } from "mobx-react";
import React from "react";
import { PropertyValueSchema, ShowPropertyValueColumns } from "./schema";
import { CreateView, ShowView } from "lego-gui-lib/lib";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

const injectDataSource = (comp: any) => inject("propertyValue")(observer(comp));

export const RemotePropertyValueEdit = injectDataSource(
  ({ propertyValue, match, ...rest }: any) => {
    const { t } = useTranslation();
    const title = t("common:edit", { domain: "hns:propertyValue:domain" });
    const history = useHistory();
    const id = {
      id: match.params.id
    };
    return (
      <ShowView
        dataSource={propertyValue.oneDataSource}
        title={title}
        id={id}
        {...rest}
        goBack={() => history.goBack()}
        fields={ShowPropertyValueColumns}
      />
    );
  }
);

export const RemotePropertyValueCreate = injectDataSource(
  ({ propertyValue, ...rest }: any) => {
    const history = useHistory();
    const { t } = useTranslation();
    const title = t("common:create", {
      domain: "hns:propertyValue:domain"
    });

    return (
      <CreateView
        dataSource={propertyValue.oneDataSource}
        title={title}
        {...rest}
        goBack={() => history.goBack()}
        fields={PropertyValueSchema}
      />
    );
  }
);
